mutation UndoCheckIn($attendeeId: ID!) {
  undoCheckIn(input: { attendeeId: $attendeeId }) {
    guest {
      id
      status
      checkedInAt
      checkedInByName
    }
  }
}
